import { ErrorMessage, Formik } from "formik";
import { useEffect, useState } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import {
  AddCropInitialValues,
  CropValidationSchema,
} from "./AddCropsMethods/FormikValidation";
import { AddOfficeProps } from "../../../../../../Type";
import {
  StaffSubmitHandler,
  addModalInitialValuesHandler,
} from "./AddCropsMethods/AddCropsModalMethods";
import TextError from "../../../../../../Components/FormikError/TextError";
import CustomButton from "../../../../../../Components/CustomElements/FormElements/CustomButton";

const AddCrop = ({ setIsOpen, modalEditData, refetch }: AddOfficeProps) => {
  const [addModalInitialValues, setAddModalInitialValues] =
    useState(AddCropInitialValues);
  const [editMode, setEditMode] = useState<boolean>(false);

  useEffect(() => {
    addModalInitialValuesHandler(
      modalEditData,
      setAddModalInitialValues,
      setEditMode
    );
  }, [modalEditData]);

  return (
    <Formik
      validationSchema={CropValidationSchema}
      initialValues={addModalInitialValues}
      enableReinitialize
      onSubmit={(values, actions) => {
        StaffSubmitHandler(
          values,
          actions,
          setIsOpen,
          refetch,
          editMode,
          modalEditData?.[0]?.id
        );
      }}
    >
      {({
        handleSubmit,
        handleChange,
        isSubmitting,
        values,
        setFieldValue,
        setFieldError,
        errors,
      }) => {
        return (
          <div className="form-wrap">
            <Form onSubmit={handleSubmit}>
              <Row className="gy-4">
                <Col lg={12}>
                  <Label>Crop Name</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    value={values?.crop_name}
                    name="crop_name"
                  />
                  <ErrorMessage name="crop_name" component={TextError} />
                </Col>
                {/* <Col md={12}>
                  <Label>Crop description</Label>
                  <Input
                    type="textarea"
                    onChange={handleChange}
                    name="crop_description"
                    value={values?.crop_description}
                    placeholder="Body"
                  />
                  <ErrorMessage name="crop_description" component={TextError} />
                </Col> */}

                <Col lg={12}>
                  <CustomButton
                    isLoading={isSubmitting}
                    label="Submit"
                    color="primary"
                    className="sm submit-btn"
                  />
                </Col>
              </Row>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddCrop;
